import { Accordion, ChakraBox, ChakraText } from '@equip.health/ui';

import { ACCORDION_WIDTH_SMALL } from '~/lib/constants';

type ToastAccordionProps = {
  data: { message: string; title: string };
  isExpanded: boolean;
  onDismiss: () => void;
  setIsExpanded: (isExpanded: boolean) => void;
};

const ToastAccordion = ({
  data,
  isExpanded,
  onDismiss,
  setIsExpanded,
}: ToastAccordionProps) => (
  <Accordion
    dismissMenu={onDismiss}
    footer={null}
    id="toast"
    isExpanded={isExpanded}
    panelMaxWidth={ACCORDION_WIDTH_SMALL}
    setIsExpanded={setIsExpanded}
    title={data.title}
  >
    <ChakraBox padding="24px">
      <ChakraText
        backgroundColor="neutral.background.secondary"
        id="toast-message"
        padding="24px"
        rounded="16px"
      >
        {data.message}
      </ChakraText>
    </ChakraBox>
  </Accordion>
);

export default ToastAccordion;
